import React from 'react';
import {
  Dialog,
  Grid,
  Button,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  gray100,
  primaryButtonBackgroundColor,
  tertiaryButtonOutlinedColor
} from '../../constants/Colors';

const styles = {
  button: {
    boxSizing: 'border-box',
    height: '44px',
    width: 'calc(50% - 10px)'
  },
  closeButtonStyle: {
    textAlign: 'right'
  },
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '24px 24px 32px 24px'
  },
  dialogtitle: {
    color: 'gray100',
    fontSize: '22px',
    fontWeight: '500'
  },
  dialogcontent: {
    color: gray100,
    fontSize: '16px',
    fontWeight: '400',
    display: 'flex',
    maxwidth: '100%',
    height: '169px',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: '0',
    ml: '56px',
    mr: '65px',
    '@media screen and (max-width:600px)': {
      ml: '24px',
      mr: '24px'
    }
  },
  buttonContainer: {
    pl: '24px',
    pr: '24px',
    pb: '24px',
    mt: '32px'
  }
};

interface EnvironmentInfoModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
}

const EnvironmentInfoModal: React.FC<EnvironmentInfoModalProps> = ({
  open,
  onClose,
  onEdit
}) => {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <Box sx={styles.dialogTitleContainer}>
          <Typography sx={styles.dialogtitle}>
            企業の環境認定情報を入力してください
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid sx={styles.dialogcontent}>
          <Typography>
            建材登録会員への申し込みには、以下の入力が必要です。
          </Typography>
          <Typography mt={2}>・企業の環境認定</Typography>
          <Typography>・認定の名称</Typography>
          <Typography mt={2}>基本情報変更ページから更新後、</Typography>
          <Typography>再度申し込みボタンを押してください。</Typography>
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          sx={styles.buttonContainer}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            fullWidth
            sx={[tertiaryButtonOutlinedColor, styles.button]}
          >
            キャンセル
          </Button>
          <Button
            onClick={onEdit}
            variant="contained"
            sx={[primaryButtonBackgroundColor, styles.button]}
            fullWidth
          >
            編集する
          </Button>
        </Grid>
      </Dialog>
    </>
  );
};

export default EnvironmentInfoModal;
